import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { azureFetch } from "../../../api/azureFetch";

function useGetModelList(filter) {

    const [modelList, setModelList] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        azureFetch("getMlModels", {where_clause: filter}).then((result) => {
            setModelList(result.data)
        }).catch((error) => {
            toast.error("Error fetching Model List")
            console.log(error)
        }).finally(() => setLoading(false));
    }, [filter]);

    return { modelList, loading }
}

export default useGetModelList;